import React from 'react';
import { Palette } from '@material-ui/icons';
import FormHtml from '../../fields/FormHtml';
import FormConfigHtml from '../../config/FormConfigHtml';
export const FormHtmlPlugin = {
    icon: React.createElement(Palette, null),
    name: 'Rich Text/Images',
    type: 'Html',
    dataTypes: ['text'],
    configurator: FormConfigHtml,
    init: type => ({
        type,
        // remove title and key for HTML / Rich Text field
        title: undefined,
        key: undefined,
        required: false
    }),
    element: FormHtml
};
//# sourceMappingURL=FormHtmlPlugin.js.map